const Endpoint: React.FC<{
  method: string;
  url: string;
}> = ({ method, url }) => (
  <div className="gap-32 py-16 px-16 md:px-24 bg-secondary flex-row mt-24 md:mt-32">
    <p className="text-secondary" style={{ textTransform: 'uppercase' }}>
      {method}
    </p>
    <p className="text-secondary" style={{ wordBreak: 'break-word' }}>
      {url}
    </p>
  </div>
);

export default Endpoint;
